import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useState, useRef } from 'react';
import PageHeader from '../../../layout/PageHeader';
import RalliesList from '../../../components/RalliesList';
import RalliesMap from '../../../components/RalliesMap';
import PageMainContent from '../../../layout/PageMainContent';
import { LOGO_SIZE } from '../../../ui/Logo';
import RalliesFilter from '../../../modules/RalliesFilter';
import Hero from '../../../layout/Hero';
import { Trans, useTranslation } from 'react-i18next';
import PublicPageLayout from '../../../layout/PublicPageLayout';
import { STATIC_IMAGES } from '../../../app.config.vars/staticImages';
import InstallPrompt from '../../../ui/InstallPrompt';
import { useSelector } from 'react-redux';
import { getLocationFilter } from '../../../store/slices/ralliesPreview';
const RalliesPage = () => {
    const { i18n } = useTranslation();
    const locationFilter = useSelector(getLocationFilter);
    const [highlightedRallyId, setHighlightedRallyId] = useState(undefined);
    const highlightTimeoutRef = useRef(null);
    const showMap = locationFilter === 1; // Location-based rallies
    const handleRallyClick = (rallyUuid) => {
        const element = document.getElementById(`rally-${rallyUuid}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Clear any existing timeout
            if (highlightTimeoutRef.current) {
                clearTimeout(highlightTimeoutRef.current);
            }
            setHighlightedRallyId(rallyUuid);
            // Set new timeout
            highlightTimeoutRef.current = setTimeout(() => {
                setHighlightedRallyId(undefined);
                highlightTimeoutRef.current = null;
            }, 5000);
        }
    };
    return (_jsx(PublicPageLayout, { children: _jsxs("div", { className: 'page-content-wrapper rallies-page', children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: '/' }), _jsx(InstallPrompt, {}), _jsxs(PageMainContent, { children: [_jsx(Hero, { imageSrc: localStorage.getItem(STATIC_IMAGES.heroBg.key) || undefined, imagePosition: 'bottom right', title: _jsx(Trans, { i18nKey: "rallies_select_page_title", components: { br: _jsx("br", {}) } }, i18n.language), backgroundColor: 'rgba(0, 161, 154, 0.2)', children: _jsx(RalliesFilter, {}) }), showMap && _jsx(RalliesMap, { onRallyClick: handleRallyClick }), _jsx(RalliesList, { highlightedRallyId: highlightedRallyId })] })] }) }));
};
export default RalliesPage;
